export const MENU_SEC_TYPES = { //過去サブスクページ
  def_text: 0, // 通常テキストメニュー
  def_movie: 1, // 通常動画メニュー
  counselor: 2, //占い師(単品)
  fortune: 3, //占術(単品)
  vis_text_a: 4, // ちょっと豪華なテキストメニューAタイプ
  todays_lucky7: 5, // TodaysLucky7
  new_menu: 6, // 新新着メニュー（個別リンク）
}

// トップ特集タイプ
export const FEATURES_SEC_TYPES = [
  { type: 0, class_name: 'def-feature-list' }, // 特集リスト
  { type: 1, class_name: 'hero-bottom-slider' }, // トップバナー下リスト
  { type: 2, class_name: 'single-banner' }, // バナーのみ
  { type: 3, class_name: 'liam-tarot' }, // リアムタロット
  { type: 4, class_name: 'todays-lucky-7' }, // Today's Lucky7
  { type: 5, class_name: 'counselors-features' }, //特集リスト（占い師）
  { type: 6, class_name: 'recommend-banner' }, //レコメンド用（トップでは使用しない）
  { type: 7, class_name: 'banner-group' }, //バナーグループ(トップは原則入会特典のみの特殊処理になるので注意)
]

export const SEC_ICON_TYPE = {
  text: 0, //テキストメニューアイコン
  movie: 1, //動画メニューアイコン
  none: 2 //なし
}

export const MENU_ITEM_TYPE = {
  // サーバからもどるitemTypeに対応
  // ※アイコンタイプと整合性ないので、後日整理する
  text: 1, //テキストメニュー
  movie: 2 //ムービーメニュー
}

export const PLAYLIST_TYPE = {
  text: 0,
  movie: 1,
  tab_text: 2,
  tab_movie: 3
}

//メニュー取得数
export const ACQUIRED_MENUS_NUMBER = 10

//終了メニューリストLSキー
export const CLOSED_MENUS_LSKEY = 'closed_menus_list'



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/MENUS.js